import React from 'react';
import { Navigate } from 'react-router-dom';

interface CreateQuoteProps {
    wekaPagePermissions?: Record<string, boolean>;
}

const CreateQuote: React.FC<CreateQuoteProps> = () => (
    <Navigate
        to="/quotes"
        replace
        state={{ openCreateQuoteModal: true }}
    />
);

export default CreateQuote;
